import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

interface ContractStatusBadgeProps {
  status: string;
  className?: string;
}

/**
 * A badge component for displaying contract status with appropriate colors.
 *
 * Uses CSS custom properties defined in index.css for consistent styling:
 * - Active: Green background (--active-status)
 * - Expired: Red background (--expired-status)
 * - Cancelled: Amber background (--cancelled-status)
 * - Default: Uses the default badge styling for unknown statuses
 */
export function ContractStatusBadge({
  status,
  className,
}: ContractStatusBadgeProps) {
  const getStatusStyles = (status: string) => {
    const normalizedStatus = status.toLowerCase();

    switch (normalizedStatus) {
      case 'active':
        return 'bg-[var(--active-status)] text-[var(--active-status-foreground)] font-bold border-transparent';
      case 'expired':
        return 'bg-[var(--expired-status)] text-[var(--expired-status-foreground)] font-bold border-transparent';
      case 'cancelled':
        return 'bg-[var(--cancelled-status)] text-[var(--cancelled-status-foreground)] font-bold border-transparent';
      default:
        return ''; // Falls back to default badge styling
    }
  };

  return (
    // <Badge className={cn(getStatusStyles(status), className)}>{status}</Badge>
    <Badge className={cn(getStatusStyles(status), className)}>{status}</Badge>
  );
}
